(function() { window.GUID_67da1776_d24e_4327_bf37_cad48ffb6819 = { getGuid: function() { return "67da1776-d24e-4327-bf37-cad48ffb6819"; } }; })();
var CS;
(function (CS) {
    class GridView extends CompuSport.Controls.Base.RefreshOnChange {
        constructor(gridView) {
            super();
            this.OverrideDeleteButton = null;
            this.OverrideAddButton = null;
            this.AddButtonCallback = null;
            this.OverrideEditButton = null;
            this.SelectionChange = null;
            this.ExtraDataReceived = null;
            this.ExtendPrepareData = null;
            this.ExtendPendingChanges = null;
            this.PreSave = null;
            this.Saved = null;
            this.Cancelled = null;
            this.IsV2 = false;
            this.RowsAdded = null;
            this.AppendTo = null;
            this.LastRefreshAjax = null;
            this.FormDialog = null;
            this.Refreshed = null;
            this.LastClickedRow = null;
            this.ExtraData = null;
            this.InResizeHeaderMode = false;
            this.HeaderInResizeMode = null;
            this.LastFocusedCell = null;
            this.DisableDblClick = false;
            this.GetDataObjectFromRefreshElementIds = function () {
                let me = this;
                let data = CompuSport.Send.PrepareData(me);
                let newData = {};
                $.each(data, function (name, val) {
                    newData[name] = val.toString();
                });
                if (me.IsV2) {
                    newData["GridViewType"] = me.GridViewType;
                    newData["LoadParamsType"] = me.LoadParamsType;
                }
                return newData;
            };
            this.GetUIRows = function () {
                var me = this;
                return $('tr:not(.GridRowNoResults)', me.GridViewBody);
            };
            let me = this;
            me.uiDiscovery(gridView);
            me.bindEvent();
            me.ExtractElementIdsFromData(this.GridView);
            me.RefreshOnElementValueChange(() => {
                me.RefreshGridData();
            });
            me.updateSortIndicatorCells();
        }
        updateSortIndicatorCells() {
            const $cells = this.GridViewBody.find('td.CellDescending, td.CellAscending');
            if (!$cells.length)
                return;
            $cells.each((_, cell) => {
                const isLoaded = $(cell).hasClass('SortIndicatorCell');
                if (isLoaded)
                    return;
                const isAscending = $(cell).hasClass('CellAscending');
                $(cell).addClass('SortIndicatorCell');
                const iconContainerId = `icon-container-${CompuSport.GenerateRandomId()}`;
                $(cell).prepend(`<div id="${iconContainerId}" class="SortIndicatorContainer"></div>`);
                const text = isAscending ? JSRess.LowerValuesFirst_Ascending : JSRess.HigherValuesFirst_Descending;
                $(cell).append(`<span class="SortIndicator">${text}</span>`);
                $(cell).css('opacity', '0'); // To prevent flickering
                const descendingArrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="layer_1" enable-background="new 0 0 32 32" viewBox="0 0 32 32"><path d="m2.3037109 20.5410156c-.3964844.3847656-.40625 1.0175781-.0214844 1.4140625l3.8457031 3.9638672c.0002441.0002441.0006104.0003662.0008545.0006104.1817627.1881104.4343262.3070068.7169189.3070068s.5351562-.1188965.7169189-.3070068c.0002441-.0002441.0006104-.0003662.0008545-.0006104l3.8466797-3.9638672c.3847656-.3964844.375-1.0292969-.0214844-1.4140625s-1.0292969-.375-1.4140625.0214844l-2.1289062 2.1940308v-15.9830933c0-.5527344-.4472656-1-1-1s-1 .4472656-1 1v15.9827881l-2.1279296-2.1937256c-.3847656-.3964844-1.0175781-.40625-1.4140625-.0214844z"/><path d="m26.8798828 12.9228516c0-.5527344-.4472656-1-1-1h-10.8515625c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h10.8515625c.5527344 0 1-.4472657 1-1z"/><path d="m23.7597656 19.0732422c0-.5527344-.4472752-1-1-1h-7.7314453c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h7.7314453c.5527249 0 1-.4472656 1-1z"/><path d="m15.0283203 24.2265625c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h4.6113281c.5527344 0 1-.4472656 1-1s-.4472656-1-1-1z"/><path d="m29 5.7734375h-13.9716797c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h13.9716797c.5527344 0 1-.4472656 1-1s-.4472656-1-1-1z"/></svg>`;
                const ascendingArrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" id="layer_1" enable-background="new 0 0 32 32" viewBox="0 0 32 32"><path d="m2.3037109 11.4589844c.194336.1884765.4453125.2822265.6962891.2822265.2607422 0 .5214844-.1015625.7177734-.3037109l2.1279907-2.1931152.0004272 15.9821777c0 .5527344.4477539 1 1 1s1-.4472656 1-1l-.0004271-15.9821777 2.1283569 2.1931152c.3852539.3964844 1.0180664.40625 1.4140625.0214844.3964844-.3847656.4057617-1.0175781.0214844-1.4140625l-3.8461914-3.9638672c-.0003052-.0003662-.0008545-.0004273-.0011597-.0007935-.1818237-.1880493-.4343262-.3068237-.7166138-.3068237s-.53479.1187744-.7166138.3068237c-.0003051.0003662-.0008544.0004273-.0011596.0007935l-3.8457031 3.9638672c-.3847657.3964843-.375 1.0292969.0214843 1.4140625z"/><path d="m26.8798828 12.9228516c0-.5527344-.4477539-1-1-1h-10.8515625c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h10.8515625c.5522461 0 1-.4472657 1-1z"/><path d="m23.7597656 19.0732422c0-.5527344-.4477539-1-1-1h-7.7314453c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h7.7314453c.5522461 0 1-.4472656 1-1z"/><path d="m15.0283203 24.2265625c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h4.6118164c.5522461 0 1-.4472656 1-1s-.4477539-1-1-1z"/><path d="m29 5.7734375h-13.9716797c-.5522461 0-1 .4472656-1 1s.4477539 1 1 1h13.9716797c.5522461 0 1-.4472656 1-1s-.4477539-1-1-1z"/></svg>`;
                const $target = $(`#${iconContainerId}`);
                if ($target.length) {
                    $target.prepend(isAscending ? ascendingArrowSVG : descendingArrowSVG);
                    $(cell).css('opacity', '1');
                }
                //CompuSport.FetchAndPrependToTarget({
                //    targetSelector: `#${iconContainerId}`,
                //    url: isAscending ? "/cdn/app/images/svg/icons/sort-asc.svg" : "/cdn/app/images/svg/icons/sort-desc.svg"
                //}).then(() => {
                //    $(cell).css('opacity', '1');
                //}).catch((error) => {
                //    console.error("Error fetching:", error);
                //    $(cell).css('opacity', '1');
                //})
            });
        }
        uiDiscovery(gridView) {
            let me = this;
            this.GridView = gridView;
            if (!this.GridView.hasClass('CSGridView')) {
                alert('Hum, ton grid ce fait voler son Id par un autre element HTML');
                return;
            }
            this.SelectedRows = $('.IsSelected', me.GridView);
            this.GridViewId = this.GridView[0].id;
            this.Id = this.GridViewId;
            this.GridTopMessages = $('.GridTopMessages', this.GridView);
            this.BtnSearch = $('.BtnSearch', this.GridView);
            this.BtnAdd = $('.BtnAdd', this.GridView);
            this.BtnEdit = $('.BtnEdit', this.GridView);
            this.BtnDelete = $('.BtnDelete', this.GridView);
            this.BtnCSV = $('.BtnCSV', this.GridView);
            this.BtnEditColumns = $('.BtnEditColumns', this.GridView);
            this.BtnRefresh = $('.BtnRefresh', this.GridView);
            this.BtnSave = $('.BtnSave', this.GridView);
            this.BtnCancel = $('.BtnCancel', this.GridView);
            this.BtnHeaderShowMoreColumns = $('.GridViewHeaderShowMore', this.GridView);
            this.IsEditable = this.GridView.data('editionmode') == "CanSaveCancel" || this.GridView.data('editionmode') == "CannotSaveCancel";
            this.IsEdited = this.GridView.data('isedited') == "True";
            this.GridViewPager = $('#' + this.GridViewId + 'Pager', this.GridView);
            this.GridViewHead = $('#' + this.GridViewId + 'THead', this.GridView);
            this.GridViewFixedHead = $('.GridViewDivFixedTHead', this.GridView);
            this.GridViewSearch = $('.GridViewSearch', this.GridView);
            this.TableContainer = $('.TableContainer', this.GridView);
            this.GridViewBody = $('.' + this.GridViewId + 'TBody', this.GridView);
            this.TotalSelectedRows = $('#' + this.GridViewId + 'SelectedTotal', this.GridView);
            this.PagerTotal = $('#' + this.GridViewId + 'PagerTotal', this.GridView);
            this.GridViewType = this.GridView.data('gridtype');
            this.LoadParamsType = this.GridView.data('loadparamstype');
            if (this.GridViewType) {
                this.IsV2 = true;
            }
            if (this.PagerTotal.length > 0) {
                this.TotalOfRowsCount = parseInt(this.PagerTotal[0].innerHTML, 10);
            }
            //this.Rows = $('tr', this.GridViewBody);
            this.Rows = this.GetUIRows();
            if ($('.GridViewControls', this.GridView).data('multiselect') == "True") {
                this.MultiSelect = true;
            }
            else {
                this.MultiSelect = false;
            }
            if ($('.GridViewControls', this.GridView).data('reorder') == "True") {
                this.Reorder = true;
                this.ActivateReorder();
                this.ColRefOrder = $('th.IsOrderRef', this.GridViewHead);
            }
            else {
                this.Reorder = false;
            }
            let sid = CSParameters.SportEventId;
            this.BaseUrl = this.GridView.data('baseurl');
            this.AutoHeight = this.GridView.data('autoheight') == "True";
            this.MinHeight = this.GridView.data('minheight');
            if (!this.IsV2) {
                this.AddUrl = this.BaseUrl + 'Add' + this.GridViewId + "/" + sid;
                this.DeleteUrl = this.BaseUrl + 'Delete' + this.GridViewId + "/" + sid;
                this.EditUrl = this.BaseUrl + 'Edit' + this.GridViewId + "/" + sid;
                this.CSVUrl = this.BaseUrl + 'CSV' + this.GridViewId + "/" + sid;
                this.UpdateUrl = this.BaseUrl + 'Update' + this.GridViewId + "/" + sid;
                this.CheckBoxesUrl = this.BaseUrl + 'CheckBoxes' + this.GridViewId + "/" + sid;
                this.BtnEditColumnsUrl = this.BaseUrl + 'GridViewEditColumns' + "/" + sid;
                this.BtnSaveUrl = this.BaseUrl + 'SaveGridViewPendingChanges/' + sid;
                this.RefreshUrl = this.BaseUrl + 'Refresh' + this.GridViewId + "/" + sid;
            }
            else {
                this.AddUrl = this.BaseUrl + 'GridViewAdd/' + sid;
                this.DeleteUrl = this.BaseUrl + 'GridViewDelete/' + sid;
                this.EditUrl = this.BaseUrl + 'GridViewEdit/' + sid;
                this.CSVUrl = this.BaseUrl + 'GridViewExport/' + sid;
                this.UpdateUrl = this.BaseUrl + 'GridViewUpdate/' + sid;
                //this.CheckBoxesUrl = this.BaseUrl + 'GridViewCheckBoxes/' + sid;
                this.BtnEditColumnsUrl = this.BaseUrl + 'GridViewEditColumns' + "/" + sid;
                this.BtnSaveUrl = this.BaseUrl + 'GridViewSavePendingChanges/' + sid;
                this.RefreshUrl = this.BaseUrl + 'GridViewRefresh/' + sid;
            }
            this.RefAutoSize = this.GridView.data('refautosize');
            this.Parameters = me.GridView.data('parameters');
            this.RefreshIsEdited();
        }
        bindEvent() {
            let me = this;
            if (CS.FormReady != undefined) {
                CS.FormReady(function (formId) {
                    if (formId == "GridViewEditColumnsForm") {
                        SetBehaviorOfEditColumns();
                    }
                });
            }
            me.GridView.data('context', me);
            let cancelTimer = null;
            if (this.GridView.data('editionmode') == "CanSaveCancel") {
                $(window).off('beforeunload.gridview');
                $(window).on('beforeunload.gridview', function (e) {
                    console.log('beforeunload gridview');
                    let editedCells = $('td.IsEdited', me.GridViewBody);
                    let length = editedCells.length;
                    if (length > 0) {
                        if (typeof (Menu) != "undefined") {
                            Menu.ShowHideMenu(false);
                        }
                        me.BtnSave.Blink(10, { css: { backgroundColor: '#0000ff', opacity: 0.25 }, duration: 500 }, { css: { backgroundColor: '#fff', opacity: 1 }, duration: 500 });
                        let div = document.createElement('div');
                        div.innerHTML = JSRess.PendingChangesWarning;
                        let decoded = div.firstChild.nodeValue;
                        let message = decoded;
                        e.returnValue = message;
                        /*Trick qui evite le budy de rester affich� sur un stay on page*/
                        cancelTimer = window.setTimeout(function () { CompuSport.trigger('cancelbusyindicator'); }, 500);
                        return message;
                    }
                });
            }
            this.PrepareHeadersEvents();
            this.PrepareSearch();
            this.PrepareContextMenu();
            this.PrepareRowsEvents();
            this.GridViewBody.attr('tabindex', 99999);
            this.GridView.off('click');
            this.TableContainer.off('scroll');
            this.TableContainer.off('click');
            this.BtnSearch.off('click');
            this.BtnAdd.off('click');
            this.BtnEdit.off('click');
            this.BtnDelete.off('click');
            this.BtnCSV.off('click');
            this.BtnEditColumns.off('click');
            this.BtnSave.off('click');
            this.BtnCancel.off('click');
            this.GridViewPager.off('change');
            this.TableContainer.scrollTop(this.Parameters.ScrollTop);
            this.TableContainer.scrollLeft(this.Parameters.ScrollLeft);
            if (typeof (MasterPage) != "undefined" && MasterPage.MasterSearch != undefined) {
                if (this.Parameters.AllowMasterSearch) {
                    MasterPage.MasterSearch.show();
                    MasterPage.MasterSearch.off('CSMasterSearch.' + this.GridViewId);
                    MasterPage.MasterSearch.on('CSMasterSearch.' + this.GridViewId, function () {
                        me.RefreshGridData();
                    });
                }
            }
            this.GridView.on('click', function (e) {
                if (me.GridViewContextMenu != null) {
                    me.GridViewContextMenu.hide();
                }
            });
            this.TableContainer.on('touchstart', function () {
            });
            var request = new CompuSport.CSRequestAnimationFrame();
            /*
            function debounce(func, wait, immediate#?) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    var later = function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            };*/
            this.TableContainer.on('scroll', function () {
                //debounce(function() {
                request.Request(function () {
                    let elementToScroll = me.TableContainer;
                    let scrollLeft = elementToScroll.scrollLeft();
                    let scrollTop = elementToScroll.scrollTop();
                    me.Parameters.ScrollLeft = Math.round(scrollLeft);
                    me.Parameters.ScrollTop = Math.round(scrollTop);
                    me.GridViewFixedHead.css('left', -me.Parameters.ScrollLeft);
                    if (me.Parameters.IsFixedGroupHeaderRows) {
                        let headerRows = $('.GroupHeaderRow td > div', elementToScroll);
                        headerRows.css('left', scrollLeft);
                    }
                });
                //}, 250);
            }).on('touchmove', function () {
                if (CSParameters.OS == "IOS") {
                    //debounce(function() {
                    request.Request(function () {
                        let elementToScroll = me.TableContainer;
                        let scrollLeft = elementToScroll.scrollLeft();
                        let scrollTop = elementToScroll.scrollTop();
                        me.Parameters.ScrollLeft = Math.round(scrollLeft);
                        me.Parameters.ScrollTop = Math.round(scrollTop);
                        me.GridViewFixedHead.css('left', -me.Parameters.ScrollLeft);
                        if (me.Parameters.IsFixedGroupHeaderRows) {
                            let headerRows = $('.GroupHeaderRow td > div', elementToScroll);
                            headerRows.css('left', scrollLeft);
                        }
                    });
                    //}, 250);
                }
                else {
                    $(this).trigger('scroll');
                }
            }).on('click', function (e) {
                if (me.StopPropagationClick == true) {
                    me.StopPropagationClick = false;
                    return;
                }
                me.ManageRowSelectionBehavior(e, null);
            });
            this.BtnSearch.on('click', function (e) {
                e.preventDefault();
                if (me.GridViewSearch.is(':visible')) {
                    me.TableContainer.removeClass('WithSearch');
                    $('.GridViewSearch', me.GridView).hide();
                    me.Parameters.SearchVisible = false;
                }
                else {
                    me.TableContainer.addClass('WithSearch');
                    $('.GridViewSearch', me.GridView).show();
                    me.Parameters.SearchVisible = true;
                }
            });
            this.BtnAdd.on('click', function (e) {
                e.preventDefault();
                if (me.GridViewAddButtonInjector) {
                    me.GridViewAddButtonInjector.ContinueToDefault = function () {
                        me.ShowAddPopup();
                    };
                    me.GridViewAddButtonInjector.Cancel = function () {
                        //ne rien faire
                    };
                    me.GridViewAddButtonInjector.OnAddClick(me.GridViewAddButtonInjector);
                }
                else {
                    me.ShowAddPopup();
                }
            });
            this.BtnEdit.on('click', function (e) {
                e.preventDefault();
                me.EditRows();
            });
            CompuSport.on('change', 'input:radio[name=RadioExportFormat]', function () {
                var csvContainer = $(".SeparatorContainer");
                if (this.value == "csv") {
                    csvContainer.show();
                }
                else {
                    csvContainer.hide();
                }
            });
            this.BtnCSV.on('click', function (e) {
                e.preventDefault();
                let listseparatorcookie = $.cookie('csvseparator');
                if (listseparatorcookie == null) {
                    listseparatorcookie = ",";
                }
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "ExportToExcel",
                    Url: me.BaseUrl + "ListSeparatorInputBox/" + CSParameters.SportEventId,
                    Data: { RadioExportFormat: 'excel', DefaultCSVSeparator: listseparatorcookie },
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                });
                popup.OnPosted = function (e) {
                    if (e.csvseparator != null) {
                        $.removeCookie('csvseparator', {
                            path: '/'
                        });
                        $.cookie('csvseparator', e.csvseparator, {
                            expires: 365, path: '/'
                        });
                        let data = me.PrepareDataToSend(me);
                        me.UpdateParameterColumnsInfos();
                        me.UpdateParameterQuerySearch();
                        if (MasterPage.TxtMasterSearch != null) {
                            me.Parameters.MasterSearch = MasterPage.TxtMasterSearch.val();
                        }
                        else {
                            me.Parameters.MasterSearch = "";
                        }
                        me.Parameters.CSVSeparator = e.csvseparator;
                        me.Parameters.RadioExportFormat = e.radioExportFormat;
                        me.Parameters.ExportMode = true;
                        data.Parameters = JSON.stringify(me.Parameters);
                        data.isPost = true;
                        //var url = me.CSVUrl + '?' + queryString + '&parameters=' + data.Parameters;
                        // window.location.assign(url);
                        CompuSport.Ajax.GetBlobPost(me.CSVUrl, data, function (response) {
                        });
                    }
                };
            });
            this.BtnDelete.on('click', function (e) {
                e.preventDefault();
                if (me.SelectedRows.length > 0) {
                    if (me.OverrideDeleteButton != null) {
                        me.OverrideDeleteButton.call(me);
                    }
                    else {
                        CompuSport.Controls.Popup.ShowConfirmDialogV2("", "<p>" + JSRess.AreYouSure + "</p>", function () {
                            let data = me.PrepareDataToSend(me);
                            data.ids = me.GetSelectedRowIds();
                            if (data.ids != "") {
                                CompuSport.Ajax.Post(me.DeleteUrl, data, function (response) {
                                    me.UpdateRowsFromPost(response);
                                    me.GridViewBody.trigger("GridDeletedRows", me);
                                });
                            }
                        });
                    }
                }
            });
            this.BtnEditColumns.on('click', function (e) {
                e.preventDefault();
                let data = me.PrepareDataToSend(me);
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    Url: me.BtnEditColumnsUrl,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST,
                    Data: data,
                    PopupId: 'GridViewEditColumnsForm'
                });
                popup.OnContentLoaded = function () {
                    SetBehaviorOfEditColumns();
                };
                popup.OnPosted = function () {
                    me.RefreshGridData();
                };
            });
            this.BtnHeaderShowMoreColumns.on('click', function () {
                me.BtnEditColumns.trigger("click");
            });
            this.BtnRefresh.on('click', function (e) {
                e.preventDefault();
                me.RefreshGridData();
            });
            this.BtnSave.on('click', function (e) {
                e.preventDefault();
                if (me.PreSave) {
                    if (!me.PreSave(this)) {
                        return;
                    }
                }
                me.SaveGrid();
            });
            this.BtnCancel.on('click', function (e) {
                e.preventDefault();
                me.CancelAllChanges();
            });
            this.GridViewPager.on('change', function () {
                me.Parameters.PagerIndex = parseInt($(this).val());
                me.RefreshGridData();
            });
            this.GridView.on('contextmenu', function (e) {
                let text = $(e.target).text();
                if (text != null && navigator.clipboard != undefined) {
                    navigator.clipboard.writeText(text).then(function () {
                        let $text = $("<div style='position:fixed; bottom: 40px; left: 50%; color: black; background-color:white; padding: 20px;'>Text copied to clipboard</div>");
                        $('body').append($text);
                        $text.show().delay(1000).fadeOut(300, () => { $text.remove(); });
                    });
                }
                e.preventDefault();
            });
            this.UpdateRowsCount();
            if (this.GridView.data['IsLoaded'] != null) {
                return;
            }
            this.GridView.data['IsLoaded'] = true;
            CompuSport.on('popup.closed.gridview', function (e, data) {
                if (data.formDialog != undefined) {
                    if (me.GridViewContextMenu.closest(data.formDialog).length == 1) {
                        me.GridViewContextMenu.remove();
                    }
                }
                else if (data.Form != undefined) {
                    if (me.GridViewContextMenu.closest(data.Form).length == 1) {
                        me.GridViewContextMenu.remove();
                    }
                }
            });
            me.RefreshHeight();
            return me;
        }
        //private PrepareData(me: GridView): any {
        //    let data = CompuSport.Send.PrepareData(me);
        //    if (me.IsV2) {
        //        data.GridViewType = me.GridViewType;
        //    }
        //    if (me.ExtendPrepareData != null) {
        //        me.ExtendPrepareData.call(this, data);
        //    }
        //    return data;
        //}
        PrepareDataToSend(me) {
            let data = CompuSport.Send.PrepareData(me);
            if (me.IsV2) {
                data.GridViewType = me.GridViewType;
                data.LoadParamsType = me.LoadParamsType;
            }
            else {
                data.gridViewId = me.GridViewId;
            }
            if (me.ExtendPrepareData != null) {
                me.ExtendPrepareData.call(this, data);
            }
            return data;
        }
        ShowAddPopup() {
            let me = this;
            if (me.OverrideAddButton != null) {
                me.OverrideAddButton.call(this);
                if (me.AddButtonCallback != null) {
                    me.AddButtonCallback.call(this, null);
                }
            }
            else {
                let popup = new CompuSport.Controls.Popup();
                let data = me.PrepareDataToSend(me);
                popup.GetAndShow({
                    PopupId: 'AddGridViewPopup' + me.GridViewId,
                    Url: me.AddUrl,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET, //'GET',
                    Data: data,
                });
                popup.OnPosted = function (response) {
                    me.UpdateRowsFromPost(response);
                };
                if (me.AddButtonCallback != null) {
                    me.AddButtonCallback.call(this, popup);
                }
            }
        }
        ;
        PrepareContextMenu() {
            let me = this;
            me.GridViewContextMenu = $('<div>');
            $(me.GridViewContextMenu).addClass('GridViewContextMenu');
            // var parent = $(me.GridView).parent();
            let parent = $("body");
            $(this.GridViewContextMenu).appendTo(parent);
            $(me.GridView).on('contextmenu', 'th.GridViewHeader', function (e) {
                let header = $(this);
                let index = header.index();
                let corrCell = $('td', me.Rows.first())[index];
                let checkableColumn = $(corrCell).hasClass('Bool');
                let sortableColumn = (me.ColRefOrder != null && me.ColRefOrder.length > 0 && me.ColRefOrder[0].cellIndex == index);
                let isEditable = true;
                if (header == null || header.data('isreadonly') == "True" || $(corrCell).hasClass('IsReadOnly')) {
                    isEditable = false;
                }
                if (checkableColumn || sortableColumn || isEditable) {
                    let contextMenu = $(me.GridViewContextMenu);
                    contextMenu.empty();
                    if (sortableColumn) {
                        contextMenu.append('<p class="ContextMenuButton" id="ApplyTheActualOrderContextMenu">' + JSRess.ApplyTheActualOrder + '</p>');
                    }
                    else if (checkableColumn) {
                        if (me.MultiSelect) {
                            contextMenu.append('<p class="ContextMenuButton" id="CheckAllContextMenu">' + JSRess.CheckAll + '</p>');
                            contextMenu.append('<p class="ContextMenuButton" id="UncheckAllContextMenu">' + JSRess.UncheckAll + '</p>');
                            contextMenu.append('<p class="ContextMenuButton" id="CheckAllSelectedContextMenu">' + JSRess.CheckAllSelected + '</p>');
                            contextMenu.append('<p class="ContextMenuButton" id="UncheckAllSelectedContextMenu">' + JSRess.UncheckAllSelected + '</p>');
                        }
                    }
                    if (!checkableColumn && isEditable && me.SelectedRows.length >= 2) {
                        contextMenu.append('<p class="ContextMenuButton" id="ApplyCustomValueContextMenu">' + JSRess.ApplyCustomValue + '</p>');
                    }
                    contextMenu.off('click', '.ContextMenuButton');
                    contextMenu.on('click', '.ContextMenuButton', function (e, data) {
                        let rows = null;
                        let ids = null;
                        let check = null;
                        if (this.id == "CheckAllContextMenu") {
                            if (me.IsEditable) {
                                rows = me.Rows;
                            }
                            else {
                                ids = me.GetRowIds();
                                rows = me.Rows; //pour la colonne select
                            }
                            check = true;
                        }
                        else if (this.id == "UncheckAllContextMenu") {
                            if (me.IsEditable) {
                                rows = me.Rows;
                            }
                            else {
                                ids = me.GetRowIds();
                                rows = me.Rows; //pour la colonne select
                            }
                            check = false;
                        }
                        else if (this.id == "CheckAllSelectedContextMenu") {
                            if (me.IsEditable) {
                                rows = me.SelectedRows;
                            }
                            else {
                                ids = me.GetSelectedRowIds();
                            }
                            check = true;
                        }
                        else if (this.id == "UncheckAllSelectedContextMenu") {
                            if (me.IsEditable) {
                                rows = me.SelectedRows;
                            }
                            else {
                                ids = me.GetSelectedRowIds();
                            }
                            check = false;
                        }
                        else if (this.id == "ApplyCustomValueContextMenu") {
                            if (me.IsEditable) {
                                rows = me.SelectedRows;
                            }
                            else {
                                ids = me.GetSelectedRowIds();
                            }
                            me.ApplyCustomValue(index);
                        }
                        else if (this.id == "ApplyTheActualOrderContextMenu") {
                            me.ApplyThisOrder();
                        }
                        if (check != null) {
                            if (me.IsEditable) {
                                let headerIndex = header[0].cellIndex;
                                let headerName = header.data('propertyname');
                                headerName = headerName.substring(1, headerName.length - 1);
                                $.each(rows, function (index, row) {
                                    let cell = $(row.cells[headerIndex]);
                                    if (headerName != "IsMultiSelected") {
                                        me.CheckUnCheckCell(cell, check);
                                    }
                                    else {
                                        me.ChangeSelectionRow($(row), check, false);
                                    }
                                });
                            }
                            else {
                                let headerName = header.data('propertyname');
                                headerName = headerName.substring(1, headerName.length - 1);
                                if (headerName != "IsMultiSelected") {
                                    me.CheckUnCheckValues(ids, headerName, check);
                                }
                                else {
                                    let headerIndex = header[0].cellIndex;
                                    $.each(rows, function (index, row) {
                                        let cell = $(row.cells[headerIndex]);
                                        //me.CheckUnCheckCell(cell, check);
                                        me.ChangeSelectionRow($(row), check, false);
                                    });
                                }
                            }
                            me.UpdateRowsCount();
                            if (me.SelectionChange != null) {
                                me.SelectionChange.call(me);
                            }
                            // me.GridViewBody.trigger("SelectionChange", me);
                        }
                        me.GridViewContextMenu.hide();
                    });
                    if (contextMenu.width() + e.clientX > CompuSport.DOM.win.width()) {
                        contextMenu.css('left', (e.clientX - contextMenu.width()) + 'px');
                    }
                    else {
                        contextMenu.css('left', (e.clientX) + 'px');
                    }
                    if (contextMenu.height() + e.clientY > CompuSport.DOM.win.height()) {
                        contextMenu.css('top', (e.clientY - contextMenu.height()) + 'px');
                    }
                    else {
                        contextMenu.css('top', (e.clientY) + 'px');
                    }
                    contextMenu.css('display', 'block');
                }
                e.preventDefault();
            });
        }
        GetPendingChanges() {
            let me = this;
            me.ApplyChangeOfLastCell();
            var pendingChanges = [];
            var editedCells = $('td.IsEdited', me.GridViewBody);
            var length = editedCells.length;
            for (var i = 0; i < length; i++) {
                var cell = editedCells[i];
                var $cell = $(cell);
                var header = me.FindHeaderOfCell(cell);
                var propertyName = header.data('propertyname');
                propertyName = propertyName.substring(1, propertyName.length - 1);
                var entityId = me.GetIdFrom($(cell).parent());
                var value = cell.innerHTML.fixspecialchar();
                if (value.indexOf("<br>") > -1) {
                    value = value.replace("<br>", "");
                }
                if ($cell.hasClass('Bool')) {
                    value = $cell.hasClass('Ckd');
                }
                pendingChanges.push({ EntityId: entityId, PropertyName: propertyName, value: value });
                if (me.ExtendPendingChanges) {
                    me.ExtendPendingChanges(entityId, pendingChanges);
                }
            }
            return JSON.stringify(pendingChanges);
        }
        PrepareSearch() {
            var me = this;
            var searchBoxes = $('td', me.GridViewHead);
            $.each(searchBoxes, function (index, hd) {
                var searchInput = $('input', hd);
                $(searchInput).off('keydown');
                $(searchInput).on('keydown', function (e) {
                    if (e.keyCode == 13) {
                        me.RefreshGridData();
                    }
                });
            });
        }
        PrepareHeadersEvents() {
            var me = this;
            $(me.GridViewFixedHead).off('click', 'th.GridViewHeader');
            $(me.GridViewFixedHead).off('click', 'th .GridViewHeaderSort');
            $(me.GridViewFixedHead).on('click', 'th.GridViewHeader', function (evt) {
                if (evt.target.className.indexOf("GridViewHeaderSort") > -1) {
                    evt.preventDefault();
                    return;
                }
                var ctrlPressed = evt.ctrlKey;
                var sortProps = me.Parameters.SortProps;
                var clickedProp = $(this).data('propertyname');
                if (clickedProp != null) {
                    if (clickedProp == "_RowInfos_") {
                        return;
                    }
                    var propAsc = clickedProp + " ASC";
                    var propDesc = clickedProp + " DESC";
                    if (sortProps.indexOf(propAsc) >= 0) {
                        if (ctrlPressed != true) {
                            sortProps = propDesc;
                        }
                        else {
                            sortProps = sortProps.replace(propAsc, propDesc);
                        }
                    }
                    else if (sortProps.indexOf(propDesc) >= 0) {
                        if (ctrlPressed != true) {
                            sortProps = propAsc;
                        }
                        else {
                            sortProps = sortProps.replace(propDesc, propAsc);
                        }
                    }
                    else if (sortProps.length > 0 && ctrlPressed == true) {
                        sortProps += "," + propAsc;
                    }
                    else {
                        sortProps = propAsc;
                    }
                    me.Parameters.SortProps = sortProps;
                    me.RefreshGridData();
                }
                else {
                    evt.preventDefault();
                }
            });
            $(me.GridView).on('mousedown', 'th .GridViewHeaderSort', function (e) {
                me.InResizeHeaderMode = true;
                me.HeaderInResizeMode = $(this).parent('th');
                var fakeHeaders = $('th.GridViewHeaderFake', me.GridView);
                me.StartPageX = e.pageX;
                me.HeaderInResizeMode.OldWidth = me.HeaderInResizeMode.width();
                me.HeaderInResizeMode.FixedHeader = $(fakeHeaders[me.HeaderInResizeMode.index()]);
            });
            $(window).mouseup(function () {
                if (me.InResizeHeaderMode && CSParameters.IsConnected) {
                    me.UpdateParameterColumnsInfos();
                    var data = {
                        Parameters: JSON.stringify(me.Parameters),
                        gridViewId: me.GridViewId
                    };
                    if (me.IsV2) {
                        data.GridViewType = me.GridViewType;
                        data.LoadParamsType = me.LoadParamsType;
                    }
                    var url = CSParameters.ControllerUrl + 'SaveGridViewColumnSize/' + CSParameters.SportEventId;
                    CompuSport.Ajax.Post(url, data, function (response) {
                    });
                }
                me.InResizeHeaderMode = false;
                me.HeaderInResizeMode = null;
                me.CheckBoxClicked = false;
            }).mousemove(function (e) {
                if (me.InResizeHeaderMode) {
                    var newPageX = e.pageX;
                    var widthOffset = me.StartPageX - newPageX;
                    var newWidth = me.HeaderInResizeMode.OldWidth - widthOffset;
                    if (newWidth > 30) {
                        me.HeaderInResizeMode.width(newWidth);
                        me.HeaderInResizeMode.FixedHeader.width(newWidth);
                    }
                }
            });
        }
        PrepareRowsEvents() {
            let me = this;
            let headers = $('th.GridViewHeader', me.GridViewHead);
            $(me.GridViewBody).off('click', 'tr');
            $(me.GridViewBody).off('dblclick', 'tr');
            $(me.GridViewBody).off('keydown', 'tr');
            $(me.GridViewBody).on('click', 'td.Bool>div', function (e) {
                let cell = $(this).parent();
                let IsChecked = cell.hasClass('Ckd');
                let cellIndex = cell.index();
                let headers = $('th.GridViewHeader', me.GridViewHead);
                let rowId = me.GetIdFrom(cell.parent('tr'));
                let header = $(headers[cellIndex]).data('propertyname');
                header = header.substring(1, header.length - 1);
                if (me.MultiSelect || header !== 'IsMultiSelected') {
                    if (header === 'IsMultiSelected') {
                        e.ctrlKey = true;
                    }
                    else {
                        e.stopPropagation();
                    }
                }
                if (!me.IsEditable) {
                    if (header != "IsMultiSelected") {
                        me.CheckUnCheckValues(rowId, header, !IsChecked);
                        e.preventDefault();
                        e.stopPropagation();
                        me.CheckBoxClicked = true;
                    }
                    else if (me.MultiSelect) {
                        e.preventDefault();
                        me.StopPropagationClick = true;
                        if (IsChecked == null) {
                            cell.toggleClass('Ckd');
                        }
                        else {
                            if (!IsChecked) {
                                cell.addClass('Ckd');
                            }
                            else {
                                cell.removeClass('Ckd');
                            }
                        }
                        me.ManageRowSelectionBehavior(e, $(this), false, header);
                    }
                }
                else {
                    e.preventDefault();
                    me.StopPropagationClick = true;
                    me.ManageRowSelectionBehavior(e, $(this), false, header);
                }
            }).on('click', 'tr', function (e) {
                e.preventDefault();
                me.StopPropagationClick = true;
                me.ManageRowSelectionBehavior(e, $(this));
            }).on('dblclick', 'tr', function (e) {
                e.preventDefault();
                let ctrlPressed = e.ctrlKey;
                let shiftPressed = e.shiftKey;
                if (ctrlPressed || shiftPressed || me.CheckBoxClicked || me.DisableDblClick) {
                    return;
                }
                if (me.BtnEdit.length > 0) {
                    me.EditRows();
                }
            }).on('keydown', function (e) {
                if (e.ctrlKey && e.keyCode == 65) {
                    e.preventDefault();
                    e.stopPropagation();
                    me.ManageRowSelectionBehavior(e, null, true);
                }
                else if (e.keyCode == 46) {
                    if ($(e.target).hasClass('EditableContent')) {
                        return;
                    }
                    if (me.BtnDelete.is(':visible')) {
                        me.BtnDelete.trigger('click');
                    }
                }
            });
        }
        ChangeSelectionRow(row, select, toggleMode) {
            if (row != null) {
                if (toggleMode) {
                    row.toggleClass("IsSelected");
                }
                else {
                    if (select == true) {
                        row.addClass("IsSelected");
                    }
                    else {
                        row.removeClass("IsSelected");
                    }
                }
                if (row.length > 0 && row[0].cells != undefined) {
                    $.each(row[0].cells, function (index, value) {
                        if ($(value).hasClass('IsMultiSelected')) {
                            if (row.hasClass("IsSelected")) {
                                $(value).addClass("Ckd");
                            }
                            else {
                                $(value).removeClass("Ckd");
                            }
                        }
                    });
                }
            }
        }
        UpdateRowsFromPost(response) {
            var me = this;
            var htmlRows;
            if (typeof (response.htmlRows) == 'undefined') {
                htmlRows = $(response);
            }
            else {
                htmlRows = $(response.htmlRows);
            }
            if (response.gridTopMessages != null && response.gridTopMessages.length > 0) {
                var messageContent = me.GridTopMessages.find('.Content');
                messageContent.empty();
                let end = response.gridTopMessages.length;
                for (var i = 0; i < end; i++) {
                    var message = response.gridTopMessages[i];
                    messageContent.append(message);
                }
                me.GridTopMessages.slideDown(150, function () {
                    var containErrors = me.GridTopMessages.find('.inerror').length > 0;
                    if (!containErrors) {
                        setTimeout(function () {
                            me.GridTopMessages.slideUp();
                        }, 2000);
                    }
                    else {
                        var btnClose = me.GridTopMessages.find('.BtnClose');
                        btnClose.on('click', function () {
                            me.GridTopMessages.slideUp();
                        });
                    }
                });
            }
            var rowsAdded = false;
            $.each(htmlRows, function (index, r) {
                var tohtmlRow = $('<div />').html(r);
                var row = $('tr', tohtmlRow);
                if (row.length > 0) {
                    var rowId = row[0].id;
                    var corrRow = $('#' + rowId, me.GridViewBody);
                    var rowState = ($(row).attr('data-csentitystate'));
                    if (rowState == "IsEdited" || rowState == "IsNewIsEdited" || rowState == "IsInError") {
                        $(corrRow).replaceWith(row);
                    }
                    else if (rowState == "IsDeleted" || rowState == "IsNewIsDeleted") {
                        corrRow.remove();
                        me.TotalOfRowsCount -= 1;
                    }
                    else { /*IsNew*/
                        me.GridViewBody.prepend(row);
                        me.TotalOfRowsCount += 1;
                        rowsAdded = true;
                    }
                }
            });
            me.UpdateRowsCount();
            me.Rows = me.GetUIRows();
            if (me.SelectionChange != null) {
                me.SelectionChange.call(me);
            }
            if (rowsAdded) {
                me.GridView.removeClass('NoResults');
            }
            else if (me.TotalOfRowsCount == 0) {
                me.GridView.addClass('NoResults');
            }
            if (rowsAdded && me.RowsAdded != null) {
                me.RowsAdded.call(me);
            }
            me.GridViewBody.trigger("SelectionChange", me);
            CompuSport.DOM.body.trigger('saved', [me, response]);
            me.RefreshHeight();
            if (response.extraData != null) {
                me.ExtraData = response.extraData;
                if (me.ExtraDataReceived != null) {
                    me.ExtraDataReceived.call(me);
                }
                me.GridViewBody.trigger("GridViewExtraDataReceived", me);
            }
            else {
                me.ExtraData = response.extraData;
            }
            me.updateSortIndicatorCells();
        }
        UpdateRowsCount() {
            var me = this;
            var selectedRowCountBefore = me.SelectedRows.length;
            me.SelectedRows = this.GridViewBody.find('.IsSelected').filter('tr');
            //Je me sert de cette valeur pour faire le pivot de selection en multiselect avec shift
            if (me.SelectedRows.length == 1) {
                me.LastClickedRow = $(me.SelectedRows[0]);
            }
            var selectCount = me.SelectedRows.length;
            if (selectedRowCountBefore > 0 && selectCount == 0) {
                me.ApplyChangeOfLastCell();
            }
            me.PagerTotal.html(me.TotalOfRowsCount);
            me.TotalSelectedRows.html(selectCount);
            if (selectCount == 0) {
                me.BtnEdit.hide();
                me.BtnDelete.hide();
            }
            else {
                me.BtnEdit.show();
                me.BtnDelete.show();
            }
        }
        GetSelectedRowIds() {
            var me = this;
            var ids = "";
            $.each(me.SelectedRows, function (index, row) {
                // ids += me.GetIdFrom(row) + ",";
                var idtoadd = me.GetIdFrom(row);
                if (idtoadd != "") {
                    ids += idtoadd + ",";
                }
            });
            if (ids.lastIndexOf(",") == ids.length - 1) {
                ids = ids.substring(0, ids.length - 1);
            }
            return ids;
        }
        GetRowIds() {
            var me = this;
            var ids = "";
            $.each(this.Rows, function (index, row) {
                // ids += me.GetIdFrom(row) + ",";
                var idtoadd = me.GetIdFrom(row);
                if (idtoadd != "") {
                    ids += idtoadd + ",";
                }
            });
            if (ids.lastIndexOf(",") == ids.length - 1) {
                ids = ids.substring(0, ids.length - 1);
            }
            return ids;
        }
        //Est-ce que cest vraiment encore utilis� cette method, messemble que cest quand on pouvait pas faire save et que ca s'appliquait direct
        CheckUnCheckValues(ids, header, check) {
            var me = this;
            var data = me.PrepareDataToSend(me);
            data.ids = ids;
            data.header = header;
            data.isChecked = check;
            CompuSport.Ajax.Post(me.CheckBoxesUrl, data, function (response) {
                me.UpdateRowsFromPost(response);
                me.GridViewBody.trigger("CheckBoxChange", me);
            });
        }
        CheckUnCheckCell(cell, check) {
            if (!cell.hasClass('Bool')) {
                return;
            }
            if (check == null) {
                cell.toggleClass('Ckd');
            }
            else {
                if (check) {
                    cell.addClass('Ckd');
                }
                else {
                    cell.removeClass('Ckd');
                }
            }
            cell.addClass('IsEdited');
            this.IsEdited = true;
            this.RefreshIsEdited();
            this.GridViewBody.trigger("CheckBoxChange", this);
        }
        RefreshPager() {
            var pagerTotal = $("#" + this.GridViewId + 'PagerTotal');
            if (this.Rows != null) {
                pagerTotal.html(this.Rows.length);
            }
        } //etrange
        RefreshGridData() {
            var me = this;
            CS.LagV2(me.Id, 150, () => {
                var data = me.RefreshAndGetDataOfGridView();
                if (me.LastRefreshAjax != null && me.LastRefreshAjax.readystate != 4 && me.LastRefreshAjax.readyState != 0) {
                    me.LastRefreshAjax.abort();
                }
                CompuSport.Ajax.Post(me.RefreshUrl, data, function (response) {
                    if (response == "") {
                        return;
                    }
                    var $response = $(response);
                    var existingGridView = $('#' + me.GridViewId);
                    if (me.AppendTo != null && existingGridView.length == 0) {
                        me.AppendTo[0].innerHTML = $response[0].outerHTML;
                    }
                    else {
                        me.GridView.replaceWith($response[0].outerHTML);
                    }
                    existingGridView = $('#' + me.GridViewId);
                    existingGridView.CSGridView(true);
                    var newGrid = eval('document.' + me.GridViewId);
                    /*Ceci permet de passer des donn�es html en plus du grid en appendant du html a la find des donn�es du grid via le controlleur*/
                    if ($response.length > 1) {
                        newGrid.ExtraData = new Array();
                        for (var i = 1; i < $response.length; i++) {
                            newGrid.ExtraData.push($response[i]);
                        }
                    }
                    //Je dois remetre les function au newGrid parce qu'apres le refresh, elle sont perdues sinon.
                    newGrid.SelectionChange = me.SelectionChange;
                    newGrid.RowsAdded = me.RowsAdded;
                    newGrid.OverrideDeleteButton = me.OverrideDeleteButton;
                    newGrid.OverrideAddButton = me.OverrideAddButton;
                    newGrid.OverrideEditButton = me.OverrideEditButton;
                    newGrid.ExtendPrepareData = me.ExtendPrepareData;
                    newGrid.Refreshed = me.Refreshed;
                    newGrid.ExtraDataReceived = me.ExtraDataReceived;
                    newGrid.RefreshHeight();
                    /*Important, le Refreshed doit etre avant le SelectionChange, sinon,l'instance du grid qui est remplac�
                     partout est remplac� en apr�s le SelectionChange et ainsi, le SelectedRows est invalide puisqu'il
                    correspond au compte d'avant*/
                    newGrid.GridViewBody.trigger("Refreshed", newGrid);
                    if (newGrid.Refreshed != null) {
                        newGrid.Refreshed.call(newGrid, $response);
                    }
                    newGrid.GridViewBody.trigger("SelectionChange", newGrid);
                    if (newGrid.SelectionChange != null) {
                        newGrid.SelectionChange.call(newGrid);
                    }
                    newGrid.updateSortIndicatorCells();
                });
            });
        }
        UpdateParameterQuerySearch() {
            var inputs = $('thead td input', this.GridView);
            var propsearch = "";
            $.each(inputs, function (index, input) {
                var watermark = $(input).data('watermark');
                var prop = $(input).data('propertyname');
                var val = $(input).val();
                if (val != watermark) {
                    propsearch += prop + "~" + val + ";";
                }
            });
            this.Parameters.SearchProps = propsearch;
        }
        ClearRows() {
            this.Rows.remove();
            this.TotalOfRowsCount = 0;
            this.UpdateRowsCount();
        }
        HideButtons() {
            this.BtnSearch.hide();
            this.BtnAdd.hide();
            this.BtnEdit.hide();
            this.BtnDelete.hide();
            this.BtnCSV.hide();
            this.BtnEditColumns.hide();
            this.BtnRefresh.hide();
            this.BtnSave.hide();
            this.BtnCancel.hide();
            this.BtnHeaderShowMoreColumns.hide();
        }
        UpdateParameterColumnsInfos() {
            var headers = $('th', this.GridViewHead);
            var colInfos = "";
            $.each(headers, function (index, value) {
                var header = value;
                var propName = $(header).data('propertyname');
                var width = Math.round($(header).width());
                colInfos += propName + ":" + width + ":" + index + ",";
            });
            this.Parameters.ColInfos = colInfos;
        }
        ActivateReorder() {
            var me = this;
            var fixHelper = function (e, ui) {
                ui.children().each(function () {
                    $(this).width($(this).width());
                });
                return ui;
            };
            this.GridViewBody.sortable({
                helper: fixHelper,
                axis: "y",
                cursor: "move",
                scroll: true,
                distance: 10,
                update: function () {
                    me.ApplyThisOrder();
                }
            });
        }
        ApplyCustomValue(cellIndexRef) {
            let me = this;
            CompuSport.Controls.Popup.ShowInputDialogV2("New value:", false, function (message, accepted) {
                if (accepted) {
                    let end = me.SelectedRows.length;
                    for (let i = 0; i < end; i++) {
                        let cellToEdit = me.SelectedRows[i].cells[cellIndexRef];
                        cellToEdit.innerHTML = message;
                        $(cellToEdit).addClass('IsEdited WithoutStyle');
                    }
                    me.IsEdited = true;
                    me.RefreshIsEdited();
                }
            });
        }
        ApplyThisOrder() {
            let me = this;
            if (me.ColRefOrder.length == 0) {
                return;
            }
            let col = me.ColRefOrder[0];
            let cellIndexRef = me.ColRefOrder[0].cellIndex;
            me.Rows = me.GetUIRows();
            let end = me.Rows.length;
            for (let i = 0; i < end; i++) {
                let cellOrder = me.Rows[i].cells[cellIndexRef];
                cellOrder.innerHTML = i + 1;
                $(cellOrder).addClass('IsEdited WithoutStyle');
            }
            me.IsEdited = true;
            me.RefreshIsEdited();
        }
        CancelAllChanges() {
            var me = this;
            me.BtnSave.hide();
            me.BtnCancel.hide();
            me.ApplyChangeOfLastCell();
            var editedCells = $('td.IsEdited', me.GridViewBody);
            editedCells.removeClass('IsEdited');
            me.RefreshGridData();
            if (me.Cancelled != null) {
                me.Cancelled();
            }
        }
        GetSelectedRowColumnValue(columnPropertyName) {
            var me = this;
            if (me.SelectedRows.length == 0) {
                return '';
            }
            var headers = $('th.GridViewHeader', me.GridViewHead);
            var header = headers.filter('[data-propertyname=_' + columnPropertyName + '_]');
            if (header.length == 0) {
                //check for data in tr used by IsDataAlwaysAvailable
                return me.SelectedRows.data(columnPropertyName.toLowerCase());
            }
            return $(me.SelectedRows[0].cells[header[0].cellIndex]).text();
        }
        GetRowColumnValue(rowId, columnPropertyName) {
            const $row = this.GridViewBody.find(`tr[id*="${rowId}"]`);
            if ($row.length == 0) {
                return "";
            }
            const headers = $("th.GridViewHeader", this.GridViewHead);
            const header = headers.filter("[data-propertyname=_" + columnPropertyName + "_]");
            if (header.length == 0) {
                //check for data in tr used by IsDataAlwaysAvailable
                return $row.data(columnPropertyName.toLowerCase());
            }
            return $($row[0].cells[header[0].cellIndex]).text();
        }
        GetIdFrom(element) {
            var id = '';
            if (typeof (element.length) == 'undefined') {
                id = element.id;
            }
            else {
                if (element.length > 0) {
                    id = element[0].id;
                }
                else {
                    return '';
                }
            }
            return id.substring(1, id.length);
        }
        EditRows() {
            var me = this;
            if (me.GridView.hasClass('NoResults')) {
                return;
            }
            if (me.OverrideEditButton != null) {
                me.OverrideEditButton.call(this);
            }
            else {
                var ids = me.GetSelectedRowIds();
                let data = me.PrepareDataToSend(me);
                data.ids = ids;
                data.Post = true;
                //Ce nest plus necessaire du au faite quon les passent via PrepareDataToSend dans data 
                //var queryString = me.GetQueryFromRefreshElementIds();
                var popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: 'EditGridViewPopup' + me.GridViewId,
                    Url: me.EditUrl /*+ '?' + queryString*/,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST, //'GET',
                    Data: data
                });
                popup.OnPosted = function (response) {
                    me.UpdateRowsFromPost(response);
                };
                /*
                if (me.Parameters.UsePopupV2) {
                    var popup = new CompuSport.Controls.Popup();
         
                    popup.GetAndShow({
                        PopupId: 'EditGridViewPopup' + me.GridViewId,
                        Url: me.EditUrl + '?' + queryString,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.POST, //'GET',
                        Data: data
                    });
                    popup.OnPosted = function (response) {
                        me.UpdateRowsFromPost(response);
                    };
                } else {
                    ShowFormPopup(me.EditUrl + '?' + queryString, data, me);
                }
                */
            }
        }
        UnselectAllRows() {
            this.ManageRowSelectionBehavior(CompuSport.DOM.body, null, false);
        }
        ManageRowSelectionBehavior(e, actualRow, selectedAllCtrlA, headername) {
            var me = this;
            var cell = $(e.target);
            if (cell.parent().hasClass('GroupHeaderRow') || cell.parents('.GridRowNoResults').length > 0) {
                return;
            }
            var ctrlPressed = e.ctrlKey;
            var shiftPressed = e.shiftKey;
            if (this.IsEditable && headername != "IsMultiSelected") {
                if (!ctrlPressed && !shiftPressed) {
                    if (e.target != undefined && e.target.tagName == 'TD') {
                        if (!cell.hasClass('Bool')) {
                            this.EditCell(cell, true);
                        }
                    }
                    else {
                        var parent = cell.parent();
                        if (parent.length > 0 && parent[0].tagName == 'TD') {
                            if (me.MultiSelect || !parent.hasClass('IsMultiSelected')) {
                                this.EditCell(parent, true);
                                if (parent.hasClass('Bool')) {
                                    return;
                                }
                            }
                        }
                    }
                }
                else {
                    this.ApplyChangeOfLastCell();
                }
            }
            if (selectedAllCtrlA == null) {
                selectedAllCtrlA = false;
            }
            var alreadySelected = false;
            if (actualRow != null) {
                alreadySelected = actualRow.hasClass('IsSelected');
            }
            //Mode multiselect
            //##################################################
            if (me.MultiSelect) {
                if (selectedAllCtrlA) {
                    $.each(me.Rows, function (i, row) {
                        me.ChangeSelectionRow($(row), true);
                    });
                }
                else if (shiftPressed) {
                    $.each(me.SelectedRows, function (i, row) {
                        me.ChangeSelectionRow($(row), false);
                    });
                    var indexClick = me.Rows.index(actualRow);
                    var indexLast = me.Rows.index(me.LastClickedRow);
                    var start = indexClick, end = indexLast;
                    if (indexClick > indexLast) {
                        start = indexLast;
                        end = indexClick;
                    }
                    else {
                        start = indexClick;
                        end = indexLast;
                    }
                    var slidedRows = me.Rows.slice(start, end);
                    if (slidedRows.length > 0) {
                        $.each(slidedRows, function (i, row) {
                            me.ChangeSelectionRow($(row), true);
                        });
                    }
                    me.ChangeSelectionRow(actualRow, true);
                    me.ChangeSelectionRow(me.LastClickedRow, true);
                }
                else if (ctrlPressed) {
                    me.ChangeSelectionRow(actualRow, null, true);
                }
                else {
                    if (alreadySelected && me.SelectedRows.length == 1) {
                        return;
                    }
                    $.each(me.SelectedRows, function (i, row) {
                        me.ChangeSelectionRow($(row), false);
                    });
                    me.ChangeSelectionRow(actualRow, true);
                }
            }
            else {
                //Mode uniselect
                //##################################################
                if (ctrlPressed || shiftPressed || alreadySelected) {
                    return;
                }
                if (me.LastClickedRow != null) {
                    me.ChangeSelectionRow(me.LastClickedRow, false);
                }
                me.ChangeSelectionRow(actualRow, true);
            }
            me.UpdateRowsCount();
            if (me.SelectionChange != null) {
                me.SelectionChange.call(me);
            }
            me.GridViewBody.trigger("SelectionChange", me);
            var sel = window.getSelection();
            sel.removeAllRanges();
        }
        EditCell(cell, clickMode) {
            var me = this;
            if (cell.hasClass('InEditMode')) {
                return;
            }
            me.ApplyChangeOfLastCell();
            var header = me.FindHeaderOfCell(cell[0]);
            if (header == null || header.data('isreadonly') == "True" || cell.hasClass('IsReadOnly')) {
                return;
            }
            if (cell.hasClass('Bool')) {
                if (clickMode) {
                    me.CheckUnCheckCell(cell);
                }
                return;
            }
            me.LastFocusedCell = cell;
            cell.addClass('InEditMode');
            var editableContent = $('<input type=\"text\" class="EditableContent CSDefault"/>');
            editableContent[0].value = cell[0].innerHTML.fixspecialchar();
            cell.data('lastval', editableContent[0].value);
            cell.html(editableContent);
            if (clickMode) {
                setTimeout(function () {
                    editableContent.focus();
                    editableContent.select();
                }, 0);
            }
            else {
                editableContent.focus();
                editableContent.select();
            }
            editableContent.on('keydown', function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    me.ApplyChangeOfLastCell();
                }
                else if (e.shiftKey && e.keyCode == 9) {
                    e.preventDefault();
                    me.NavigateCell('Left');
                }
                else if (e.keyCode == 9) {
                    e.preventDefault();
                    me.NavigateCell('Right');
                }
                else if (e.keyCode == 38) {
                    e.preventDefault();
                    me.NavigateCell('Up');
                }
                else if (e.keyCode == 40) {
                    e.preventDefault();
                    me.NavigateCell('Down');
                }
            }).on('keyup', function (e) {
                if (e.keyCode == 9 || /*TAB*/
                    e.keyCode == 16 || /*SHIFT*/
                    e.keyCode == 17 || /*CTRL*/
                    e.keyCode == 18 || /*ALT*/
                    e.keyCode == 20 || /*CAPS LOCK*/
                    e.keyCode == 37 || /*LEFT ARROW*/
                    e.keyCode == 38 || /*UP ARROW*/
                    e.keyCode == 39 || /*RIGHT ARROW*/
                    e.keyCode == 40 || /*DOWN ARROW*/
                    e.keyCode == 45 || /*INSERT*/
                    e.keyCode == 144 /*NUM LOCK*/) {
                    return;
                }
                me.CheckIfHasChangedAndGetNewValue(cell, editableContent);
            });
        }
        ApplyChangeOfLastCell() {
            var me = this;
            if (me.IsEditable) {
                if (me.LastFocusedCell != null) {
                    me.LastFocusedCell.removeClass('InEditMode');
                    var keepContent = $('.EditableContent', me.LastFocusedCell);
                    keepContent.off('keyup');
                    keepContent.off('keydown');
                    keepContent.remove();
                    me.LastFocusedCell[0].innerHTML = me.CheckIfHasChangedAndGetNewValue(me.LastFocusedCell, keepContent);
                    me.LastFocusedCell = null;
                }
            }
        }
        CheckIfHasChangedAndGetNewValue(cell, editableContent) {
            var me = this;
            if (cell.data('lastval') == undefined) {
                return;
            }
            if (editableContent.length == 0) {
                return;
            }
            var value = editableContent[0].value;
            if (cell.data('lastval') != value) {
                cell.addClass('IsEdited');
                me.IsEdited = true;
                me.RefreshIsEdited();
                return value;
            }
            return cell.data('lastval');
        }
        FindHeaderOfCell(cell) {
            if (cell == null) {
                return null;
            }
            return $($('th', this.GridViewHead)[cell.cellIndex]);
        }
        NavigateCell(direction) {
            if (direction == "Left") {
                let nextCell = this.LastFocusedCell.prev();
                this.EditCell(nextCell, false);
                return;
            }
            else if (direction == "Right") {
                let nextCell = this.LastFocusedCell.next();
                this.EditCell(nextCell, false);
                return;
            }
            else if (direction == "Down") {
                let nextCell = $(this.LastFocusedCell.closest('tr').next()).children().eq(this.LastFocusedCell[0].cellIndex);
                this.EditCell(nextCell, false);
                return;
            }
            else if (direction == "Up") {
                let nextCell = $(this.LastFocusedCell.closest('tr').prev()).children().eq(this.LastFocusedCell[0].cellIndex);
                this.EditCell(nextCell, false);
                return;
            }
            //if (nextCell.length > 0) {
            //    this.NavigateCell(direction, nextCell.next());
            //}
        }
        RefreshIsEdited() {
            var me = this;
            clearTimeout(me.RefreshIsEditedTimeout);
            me.RefreshIsEditedTimeout = setTimeout(function () {
                if (me.GridView.data('editionmode') == "CanSaveCancel") {
                    if (me.IsEdited) {
                        me.BtnSave.show();
                        me.BtnCancel.show();
                        me.BtnSave.Blink(10, { css: { backgroundColor: '#0000ff', opacity: 0.25 }, duration: 500 }, { css: { backgroundColor: '#fff', opacity: 1 }, duration: 500 });
                    }
                    else {
                        me.BtnSave.hide();
                        me.BtnCancel.hide();
                    }
                }
            }, 500);
        }
        RefreshAndGetDataOfGridView() {
            this.Parameters.PendingChanges = this.GetPendingChanges();
            var data = this.PrepareDataToSend(this);
            this.UpdateParameterColumnsInfos();
            this.UpdateParameterQuerySearch();
            if (MasterPage.TxtMasterSearch != undefined) {
                this.Parameters.MasterSearch = MasterPage.TxtMasterSearch.val();
            }
            this.Parameters.SelectedRowIds = this.GetSelectedRowIds();
            data.Parameters = JSON.stringify(this.Parameters);
            return data;
        }
        RefreshHeight() {
            var me = this;
            if (!me.AutoHeight) {
                return;
            }
            var height = (90 + me.Rows.length * 26);
            if (me.TotalOfRowsCount == 0) {
                height += 50;
            }
            var container = me.GridView.parent();
            container.css('height', height + 'px');
            container.css('minheight', me.MinHeight + 'px');
        }
        SaveGrid() {
            var me = this;
            me.BtnSave.hide();
            me.BtnCancel.hide();
            if (!me.IsEdited) {
                return;
            }
            var data = me.PrepareDataToSend(me);
            var otherParams = [];
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    otherParams.push(key + '=' + data[key]);
                }
            }
            data.otherParams = otherParams;
            data.gridViewId = me.GridViewId;
            data.pendingChanges = me.GetPendingChanges();
            CompuSport.Ajax.Post(me.BtnSaveUrl, data, function (result) {
                var _a;
                if (result.refreshAll != undefined) {
                    me.RefreshGridData();
                }
                else {
                    me.UpdateRowsFromPost(result);
                    me.IsEdited = false;
                    me.RefreshIsEdited();
                }
                (_a = me.Saved) === null || _a === void 0 ? void 0 : _a.call(me, result);
            });
        }
        downloadURL(url, callback) {
            var hiddenIFrameID = 'hiddenDownloader' /*+ count++*/;
            var iframe = document.createElement('iframe');
            iframe.id = hiddenIFrameID;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            iframe.src = url;
            if (callback != null) {
                callback();
            }
        }
    }
    CS.GridView = GridView;
    class GridViewAddButtonInjector {
        static Inject(gridView, onAddClick2) {
            let gridViewInjector = new GridViewAddButtonInjector();
            gridView.GridViewAddButtonInjector = gridViewInjector;
            gridViewInjector.OnAddClick = onAddClick2; //voir pour le parametre
            return gridViewInjector;
        }
        ;
    }
    CS.GridViewAddButtonInjector = GridViewAddButtonInjector;
})(CS || (CS = {}));

//# sourceMappingURL=cs.gridview.js.map
